import React from "react";
import "../../../css/googleAccount.css";
import LoginButton from "components/molecules/LoginButton";
import { getLeadLinkedinURL } from "helpers/Sources/linkedin";

const LinkedinLogin = ({
    isLoading,
    onLogin,
    disabled,
    fetcherAction = getLeadLinkedinURL,
    label = "Connect with Linkedin",
}) => (
    <LoginButton
        code="linkedin"
        getAuthUrl={() =>
            fetcherAction().then((r) =>
                r?.status && r?.data?.url ? r.data.url : null,
            )
        }
        paramNames={["code", "state"]}
        onSuccess={onLogin}
        dataTransform={(params) => ({
            code: params.code,
            state: params.state,
        })}
        logoSrc="/assets/images/typeImages/lead/sources/linkedin.png"
        buttonText={label}
        className="btn btn-block source-button-mui linkedinBtn"
        disabled={disabled}
        isLoadingExternal={isLoading}
    />
);

export default LinkedinLogin;
